var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h5',{staticClass:"text-center mt-3"},[_vm._v(" Logged in successfully, redirecting you to your dashboard ")])])}]

export { render, staticRenderFns }